import React from "react";
import styles from "./Content.module.scss";
import { Col, Row } from "reactstrap";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const Content = ({
  currentProduct,
  setOpenEditProductModal,
  toggle,
  colorsArray,
}) => {
  return (
    <div className={styles._content}>
      <Row>
        <Col sm="7" className={styles._content__left}>
          <div className={styles._content__left__wrapper}>
            <div className={styles._content_header}>
              <h1 className={styles._content_header_title}>
                {currentProduct?.name || "-"}
              </h1>
              <button
                className={styles._content_header_button}
                onClick={() => {
                  setOpenEditProductModal(true);
                  toggle();
                  // setOpenSpotsModal(true);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.16675 1.6665H7.50008C3.33341 1.6665 1.66675 3.33317 1.66675 7.49984V12.4998C1.66675 16.6665 3.33341 18.3332 7.50008 18.3332H12.5001C16.6667 18.3332 18.3334 16.6665 18.3334 12.4998V10.8332"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.3666 2.51688L6.7999 9.08354C6.5499 9.33354 6.2999 9.82521 6.2499 10.1835L5.89157 12.6919C5.75823 13.6002 6.3999 14.2335 7.30823 14.1085L9.81657 13.7502C10.1666 13.7002 10.6582 13.4502 10.9166 13.2002L17.4832 6.63354C18.6166 5.50021 19.1499 4.18354 17.4832 2.51688C15.8166 0.850211 14.4999 1.38354 13.3666 2.51688Z"
                    stroke="white"
                    strokeWidth="1.5"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.425 3.4585C12.9834 5.45016 14.5417 7.0085 16.5417 7.57516"
                    stroke="white"
                    strokeWidth="1.5"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Edit
              </button>
            </div>

            <div className={styles._content_body}>
              <h2 className={styles._content_body_title}>
                {currentProduct?.description || "-"}
              </h2>
              <div className={styles._content_body_price_wrapper}>
                <h6 className={styles._content_body_price}>
                  ${currentProduct?.price || "-"}
                </h6>
                <p className={styles._content_body_rating}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M6.99821 0.729004C7.6103 0.729004 8.09243 1.19131 8.40019 1.81512L9.42809 3.88785C9.45924 3.952 9.53314 4.04233 9.64421 4.12496C9.75516 4.20751 9.86384 4.25304 9.93529 4.26505L11.7959 4.57675C12.468 4.68968 13.0313 5.01912 13.2142 5.59278C13.3969 6.16596 13.1292 6.7616 12.6459 7.24577L12.6454 7.24629L11.2 8.7037C11.1427 8.76145 11.0785 8.87024 11.0383 9.01199C10.9983 9.1528 10.9947 9.28108 11.0129 9.36391L11.0131 9.36508L11.4266 11.168C11.5982 11.9183 11.5413 12.6624 11.0121 13.0515C10.4811 13.4418 9.75539 13.2687 9.09611 12.8761L7.352 11.8351C7.27874 11.7913 7.15297 11.7559 7.00113 11.7559C6.85039 11.7559 6.722 11.7909 6.64395 11.8363L6.64284 11.8369L4.90217 12.8759C4.24368 13.2699 3.51888 13.4398 2.9878 13.0491C2.45894 12.66 2.39924 11.9173 2.5713 11.1676L2.98476 9.36508L2.98501 9.36391C3.00314 9.28108 2.9996 9.1528 2.95962 9.01199C2.91937 8.87024 2.8552 8.76145 2.79791 8.7037L1.3514 7.24519C0.871199 6.76102 0.604359 6.1659 0.785624 5.59357C0.967414 5.01957 1.52965 4.68972 2.20218 4.57671L4.06126 4.26528L4.06185 4.26518C4.13 4.25336 4.23706 4.20833 4.34777 4.12557C4.45868 4.04265 4.53275 3.95212 4.56397 3.88785L4.56555 3.88464L5.5921 1.81457L5.59251 1.81375C5.90324 1.19047 6.38682 0.729004 6.99821 0.729004Z"
                      fill="url(#paint0_linear_1154_13081)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_1154_13081"
                        x1="7.00021"
                        y1="0.728709"
                        x2="7.00021"
                        y2="13.2718"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#ECD40D" />
                        <stop offset="1" stop-color="#FFA929" />
                      </linearGradient>
                    </defs>
                  </svg>
                  {currentProduct?.rating || "4.5"}
                </p>
              </div>

              <Link
                to={currentProduct?.productURL}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button className={styles._content_body_button}>Order</button>
              </Link>

              <hr className={styles._hr} />

              <div className={styles._content_body_details}>
                <div className={styles._content_body_details__item}>
                  <h6 className={styles._content_body_details__item__label}>
                    Available Colors
                  </h6>
                  <p className={styles._content_body_details__item__value}>
                    {colorsArray?.length ? (
                      colorsArray.map((color, index) => (
                        <div
                          style={{
                            borderRadius: "50%",
                            background: color,
                            width: "24px",
                            height: "24px",
                          }}
                          key={index}
                        />
                      ))
                    ) : (
                      <>-</>
                    )}
                  </p>
                </div>
                <div className={styles._content_body_details__item}>
                  <h6 className={styles._content_body_details__item__label}>
                    Country Of Origin
                  </h6>
                  <p className={styles._content_body_details__item__value}>
                    {currentProduct?.country || "-"}
                  </p>
                </div>
              </div>

              <div className={styles._content_body_details}>
                <div className={styles._content_body_details__item}>
                  <h6 className={styles._content_body_details__item__label}>
                    Expiration Date
                  </h6>
                  <p className={styles._content_body_details__item__value}>
                    {currentProduct?.expirationTime
                      ? format(
                          new Date(currentProduct?.expirationTime),
                          "dd MMMM yyyy"
                        )
                      : "-"}
                  </p>
                </div>

                <div className={styles._content_body_details__item}>
                  <h6 className={styles._content_body_details__item__label}>
                    Brand
                  </h6>
                  <p className={styles._content_body_details__item__value}>
                    {currentProduct?.brand || "-"}
                  </p>
                </div>
              </div>

              {/* <div className={styles._content_body_details}>
                <div
                  className={styles._content_body_details__item}
                  style={{
                    width: "100%",
                  }}
                >
                  <h6 className={styles._content_body_details__item__label}>
                    Order Link
                  </h6>
                  <Link
                    to={currentProduct?.productURL}
                    className={styles._content_body_details__link__value}
                  >
                    {currentProduct?.productURL}
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        </Col>
        <Col sm="5">
          <div className={styles._content__right}>
            {currentProduct?.images?.[0] && (
              <div className={styles._content_right_img_box}>
                <img src={currentProduct?.images?.[0]} alt="" />
              </div>
            )}

            <Row Gutters={"1"} className={styles._content_right_2nd_image}>
              {currentProduct?.images?.[1] && (
                <Col sm="6">
                  <div className={styles._content_right_2nd_img_box}>
                    <img src={currentProduct?.images?.[1]} alt="" />
                  </div>
                </Col>
              )}
              {currentProduct?.images?.[2] && (
                <Col sm="6">
                  <div className={styles._content_right_2nd_img_box}>
                    <img src={currentProduct?.images?.[2]} alt="" />
                  </div>
                </Col>
              )}
            </Row>

            <Row Gutters={"1"} className={styles._content_right_2nd_image}>
              {currentProduct?.images?.[3] && (
                <Col sm="6">
                  <div className={styles._content_right_2nd_img_box}>
                    <img src={currentProduct?.images?.[3]} alt="" />
                  </div>
                </Col>
              )}
              {currentProduct?.images?.[4] && (
                <Col sm="6">
                  <div className={styles._content_right_2nd_img_box}>
                    <img src={currentProduct?.images?.[4]} alt="" />
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Content;
